import CommonMemberTable from '../commonModule/CommonMemberTable';

const MemberTable = () => {
  return <CommonMemberTable status='active' title={'Active Members'} />;
};

export default MemberTable;
